export function compareDate(v1, v2) {
  const parseDate = (dateStr) => {
    if (dateStr === "-") {
      return null;
    }
    const [day, month, year] = dateStr.split(".");
    return new Date(year, month - 1, day);
  };

  return parseDate(v1) - parseDate(v2);
}

export function compareDateExtended(v1, v2) {
  const parseDateTime = (dateTimeStr) => {
    if (dateTimeStr === "-") {
      return null;
    }
    const [datePart, timePart] = dateTimeStr.split(" ");
    const [day, month, year] = datePart.split(".");
    const [hours = 0, minutes = 0, seconds = 0] = timePart
      ? timePart.split(":").map(Number)
      : [];
    return new Date(year, month - 1, day, hours, minutes, seconds);
  };

  return parseDateTime(v1) - parseDateTime(v2);
}

export function formatDate(date) {
  if (date) {
    return new Date(date)
      .toLocaleDateString("cs-CZ", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\.\s+/g, ".");
  }
  return "-";
}

export function formatDateExtended(date) {
  return new Date(date)
    .toLocaleDateString("cs-CZ", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
    .replace(/\.\s+/g, ".");
}
